import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import type { GridPlugin, GridPluginAttachContext } from '../../core/interfaces/grid-context.types';
import { GRID_PLUGIN } from '../../core/tokens/grid-plugin.token';

/**
 * Plugin de exportação. O documento de arquitetura usa `exportToExcel()` como exemplo,
 * mas a POC usa apenas AG Grid Community (ver decisão registrada no relatório) — Excel
 * (.xlsx) nativo é recurso Enterprise. Por isso o método público é `exportToCsv()`.
 */
@Component({
  selector: 'company-grid-export-plugin',
  exportAs: 'companyExporter',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '',
  providers: [{ provide: GRID_PLUGIN, useExisting: CompanyGridExportPlugin }],
})
export class CompanyGridExportPlugin implements GridPlugin {
  readonly pluginId = 'export';

  readonly fileName = input('export');

  private context: GridPluginAttachContext | null = null;

  attach(context: GridPluginAttachContext): void {
    this.context = context;
  }

  exportToCsv(): void {
    this.context?.bridge.exportToCsv(this.fileName());
  }
}
